$(function() {
	//Catering Product List - Filter Allergen
	$(".menu-filter").on("click", ".mf-clear", function(e) {
		$(".mf-tag--active").removeClass("mf-tag--active");

		$(this).addClass("mf-clear--hidden");

		updateCateringMenu(
			$(this).data("controller"),
			$(this).data("locationId"),
			$(this).data("containerId"),
			$(this).data("datasource"),
			"",
			""
		);
		e.preventDefault();
	});

	$(".menu-filter .mf-tag-wrap").on("click", "button", function() {
		$(this).toggleClass("mf-tag--active");

		if ($(".mf-tag--active").length > 0) {
			$(".mf-clear").removeClass("mf-clear--hidden");
		} else {
			$(".mf-clear").addClass("mf-clear--hidden");
		}

		updateCateringMenu(
			$(this).data("controller"),
			$(this).data("locationId"),
			$(this).data("containerId"),
			$(this).data("datasource"),
			$(this).data("allergenDxeName"),
			$("#appliedfilters").data("filter")
		);
	});

	function updateCateringMenu(
		controller,
		locationId,
		containerId,
		datasourceId,
		allergenDxeName,
		appliedFilters
	) {
		$.ajax({
			url: controller,
			type: "GET",
			data: {
				LocationId: locationId,
				AppliedFilters: appliedFilters,
				AllergenDxeName: allergenDxeName,
				filterList: "",
				DatasourceId: datasourceId
			}
		}).done(function(partialViewResult) {
			$("#" + containerId).html(partialViewResult);
			$(".menu-sticky").show();
			$(".menu-sticky .ms-link").hide();
			$(".menu-grid-heading").each(function() {
				$(
					'.menu-sticky .ms-link[href$="' + $(this).data("anchor") + '"]'
				).show();
			});
		});
	}
});
